import React from "react";
import "../../CSS/Industries.css";

function Logistics() {
    return (
        <>
            
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">

                    <div className="industry-detail-hero-content">

                        <h1>
                            Solutions for Logistics
                        </h1>

                        <p style={{ color: '#FF7D37' }}>
                            Improve transportation and logistics operations
                            with software, tracking, management systems,
                            and digital business solutions.
                        </p>

                    </div>

                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Smarter Technology for Logistics Operations
                            </h2>

                            <p>
                                Logistics businesses require efficient systems
                                to manage orders, transportation, inventory,
                                customers, and operations.
                            </p>

                            <p>
                                We develop customized solutions to help
                                logistics businesses organize and improve
                                their digital workflows.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/logistics.png"
                                alt="Logistics Technology Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Logistics & Transport</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-truck"></i>
                            <h3>Transportation Management</h3>
                            <p>Software solutions for managing transportation operations.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-box-seam"></i>
                            <h3>Order Management</h3>
                            <p>Digital systems for managing orders and business workflows.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-geo-alt"></i>
                            <h3>Tracking Solutions</h3>
                            <p>Technology solutions for tracking operational information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-bar-chart"></i>
                            <h3>Reports & Analytics</h3>
                            <p>Reports and dashboards for operational decision making.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default Logistics;